import {
  Avatar,
  Clickable,
  Col,
  Dropdown,
  Icon,
  Input,
  Modal,
  Row,
  SegmentControl,
  Text
} from 'components';
import { useInfiniteScroll } from 'core';
import { Api, theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

let timer;
const SearchUsers = ({ title, handleSelect, type, selected = [], multiple, excludeType }) => {
  const [visible, setVisible] = useState(false),
    [loading, setLoading] = useState(false),
    [selectedOpt, setSelectedOpt] = useState(0),
    [text, setText] = useState(''),
    [data, setData] = useState([]),
    [listEndReached, setListEndReached] = useState(false),
    modalRef = useRef(null),
    { t } = useTranslation();

  useInfiniteScroll('userList', () => searchUsers());

  useEffect(() => {
    setListEndReached(false);

    searchUsers(true);
  }, [text, type]);

  async function searchUsers(searchNew) {
    const getRecent = multiple && !text.length;

    clearTimeout(timer);

    if (listEndReached && !searchNew) return;

    timer = setTimeout(async () => {
      setLoading(true);

      const res = getRecent
        ? await Api.get('/posts/getRecentTags')
        : await Api.post('/users/search', {
            text,
            type,
            excludeType,
            skip: (!searchNew && data?.length) || 0
          });
      setLoading(false);

      if (!res) return;
      if (!res?.length) return searchNew ? setData([]) : setListEndReached(true);

      setData(searchNew || getRecent ? res : [...data, ...res]);
    }, 300);
  }

  function handleClick(opt) {
    if (!multiple) {
      setVisible(false);
      return handleSelect(opt);
    }

    if (selected.find((x) => x._id === opt._id))
      return handleSelect(selected.filter((x) => x._id !== opt._id));

    handleSelect([opt, ...selected]);
  }

  return (
    <Row wid="100%" pos="relative">
      <Dropdown
        title={title}
        onClick={() => setVisible(!visible)}
        selected={multiple ? !!selected.length && `${selected.length} people` : selected}
      />

      <Modal visible={visible} wid="400px" closeModal={() => setVisible(false)}>
        <Col
          bg="#fff"
          pad="16px 24px 16px 16px"
          hasRadius="16px"
          scrollY
          ht="400px"
          wid="calc(100% - 40px)"
          ref={modalRef}
          start
          gap="8px"
          noFlex
          id="userList"
        >
          <Input
            marg="14px 0 0"
            placeholder={t('common.searchDotDotDot')}
            value={text}
            onChange={(e) => setText(e.target.value)}
            wid="85%"
          />

          {multiple && (
            <Col wid="100%" noFlex gap="8px">
              <SegmentControl
                options={[t('common.fan'), t('common.athlete')]}
                small
                textStyle={{
                  b2: true
                }}
                selectedIdx={selectedOpt}
                handleSelect={setSelectedOpt}
                marg="0 0 8px"
              />

              {selected.map((x) => (
                <Clickable key={x._id} onClick={() => handleClick(x)}>
                  <Row start center between wid="100%">
                    <Row center>
                      <Avatar user={x} small />
                      <Text marg="0 0 0 8px">{x.name}</Text>
                    </Row>

                    <Icon type="close" col={theme.GREY_60} dimensions={12} />
                  </Row>
                </Clickable>
              ))}

              <Text h2 marg="8px 0 0">
                {t('add.recent')}
              </Text>
            </Col>
          )}

          {data
            .filter((x) =>
              multiple
                ? !selected.map((x) => x._id).includes(x._id) &&
                  x.type === (selectedOpt ? 'athlete' : 'fan')
                : true
            )
            .map((x) => (
              <Clickable key={x._id} onClick={() => handleClick(x)}>
                <Row start center>
                  <Avatar user={x} small />
                  <Text marg="0 0 0 8px">{x.name}</Text>
                </Row>
              </Clickable>
            ))}

          {!data.length && !loading && <Text>{t('add.noUserFound')}</Text>}
        </Col>
      </Modal>
    </Row>
  );
};

export default SearchUsers;
